import { render, staticRenderFns } from "./EditKondisiJenisBarang.vue?vue&type=template&id=56e15aab&"
import script from "./EditKondisiJenisBarang.vue?vue&type=script&lang=js&"
export * from "./EditKondisiJenisBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports